'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/tag/style/css.js
// module id = 595
// module chunks = 0